import React from 'react';
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Banner from '../Banner';
import { withInvitation } from '../../containers/withInvitation';
import AcceptDomainInvitationButton from './AcceptDomainInvitationButton';


const styles = theme => ({
  button: {
    backgroundColor: 'white',
    color: 'black',
    marginLeft: 16,
  },
});

const DomainInvitationBanner = ({
  acceptDomainInvitation,
  domainInvitation,
  classes,
}) => (
  <Banner 
    actions={
      [
        <AcceptDomainInvitationButton
          key="accept"
          color="default"
          variant="contained"
          invitation={domainInvitation}
          handleAccept={acceptDomainInvitation}
          className={classes.button}
        />
        ,
      ]
    }
  >
    <Typography>
      <FormattedMessage 
        id='subscription.banner.info.inviteToUse.domainRegistered.license' 
        values={{
          productName: domainInvitation.licence
          // FIXME: an invitation that has just been sent has no attached licence
          // hence no attached product
          ? domainInvitation.licence.plan.product.name
          : '',
          ownerEmail: domainInvitation.owner.email,
          domainName: domainInvitation.domain
        }}
      /> 
    </Typography>
  </Banner>
)

DomainInvitationBanner.propTypes = {
  classes: PropTypes.object.isRequired,
  domainInvitation: PropTypes.object.isRequired,
  acceptDomainInvitation: PropTypes.func.isRequired,
};

export default withStyles(styles)(
  withInvitation(DomainInvitationBanner)
);


// WEBPACK FOOTER //
// ./src/components/domains/DomainInvitationBanner.js